export const auditTranslations = {
  ru: {
    'audit.title': 'Журнал аудита',
    'audit.subtitle': 'Кто, когда и с каким объектом выполнил критичное действие. Откройте строку — увидите детали и ссылку на объект.',
    'audit.narrative.system': 'Система',
    'audit.narrative.excludeRule': '{user}: операция на {amount} {currency} исключена как «{category}»; ключ «{pattern}», дополнительно исключено {count}.',
    'audit.narrative.manualMatch': '{user}: контрагент «{counterparty}» сопоставлен вручную.',
    'audit.narrative.matchRule': '{user}: создано правило «{pattern}» → «{counterparty}».',
    'audit.narrative.generic': '{user}: {message} — {entity}.',
    'audit.export.csv': 'CSV',
    'audit.export.pdf': 'PDF',
    'audit.column.time': 'Время',
    'audit.column.user': 'Пользователь',
    'audit.column.action': 'Действие',
    'audit.column.object': 'Объект',
    'audit.column.message': 'Что произошло',
    'audit.column.details': 'Детали',
    'audit.filter.action': 'Тип действия',
    'audit.filter.entityType': 'Тип объекта',
    'audit.filter.entityId': 'ID объекта',
    'audit.filter.userEmail': 'Email пользователя',
    'audit.filter.from': 'С даты (UTC)',
    'audit.filter.to': 'По дату (UTC)',
    'audit.filter.clear': 'Сбросить фильтры',
    'audit.pagination.prev': 'Назад',
    'audit.pagination.next': 'Далее',
    'audit.pagination.summary': 'Стр. {page} · {total} записей',
    'audit.drawer.title': 'Запись аудита',
    'audit.drawer.openObject': 'Открыть объект',
    'audit.drawer.rawMessage': 'Исходное сообщение',
    'audit.drawer.details': 'Технические детали',
    'audit.drawer.noDetails': 'Дополнительных деталей к записи нет — смотрите тип действия и объект.',
    'audit.drawer.copyId': 'ID записи',
    'audit.drawer.highlight.reason': 'Причина',
    'audit.drawer.highlight.amount': 'Сумма',
    'audit.drawer.highlight.fileName': 'Файл',
    'audit.drawer.highlight.status': 'Статус',
    'audit.drawer.highlight.changes': 'Изменения',
    'audit.empty.title': 'Нет записей',
    'audit.empty.description': 'По текущим фильтрам событий не найдено.',
    'audit.hasDetails': 'есть JSON',
    'audit.action.created': 'Создание',
    'audit.action.updated': 'Изменение',
    'audit.action.deleted': 'Удаление',
    'audit.action.login': 'Вход',
    'audit.action.logout': 'Выход',
    'audit.action.import': 'Импорт',
    'audit.action.match': 'Сопоставление',
    'audit.action.allocate': 'Распределение',
    'audit.action.postPayment': 'Проведение платежа',
    'audit.action.sync': 'Синхронизация',
    'audit.action.reconcile': 'Сверка',
    'audit.action.approve': 'Утверждение',
    'audit.action.cancel': 'Отмена',
    'audit.action.anomalyDetected': 'Аномалия обнаружена',
    'audit.action.anomalyAcknowledged': 'Аномалия принята',
    'audit.action.anomalyResolved': 'Аномалия закрыта',
    'audit.action.anomalyDismissed': 'Аномалия отклонена',
    'audit.action.notificationRead': 'Уведомление прочитано',
    'audit.action.reconciliationRetryRequested': 'Повтор сверки',
    'audit.action.backOfficeVerificationRecorded': 'Проверка back-office',
    'audit.action.notificationReadAll': 'Все уведомления прочитаны',
    'audit.action.softDeleted': 'Мягкое удаление',
    'audit.action.restored': 'Восстановление',
    'audit.action.pendingHardDelete': 'Ожидает жёсткого удаления',
    'audit.action.hardDeleted': 'Жёсткое удаление',
    'audit.action.cancelledByHardDelete': 'Отменено жёстким удалением',
    'audit.action.export': 'Экспорт',
    'audit.action.documentUploaded': 'Документ загружен',
    'audit.action.recognitionQueued': 'Распознавание в очереди',
    'audit.action.recognitionStarted': 'Распознавание начато',
    'audit.action.recognitionCompleted': 'Распознавание завершено',
    'audit.action.recognitionFailed': 'Ошибка распознавания',
    'audit.action.recognitionRetryRequested': 'Повтор распознавания',
    'audit.action.recognitionRowCorrected': 'Строка распознавания исправлена',
    'audit.action.recognitionConfirmed': 'Распознавание подтверждено',
    'audit.action.recognitionRejected': 'Распознавание отклонено',
    'audit.action.trainingCandidateCreated': 'Кандидат обучения создан',
    'audit.action.trainingCandidateAnonymized': 'Кандидат обезличен',
    'audit.action.trainingExampleApproved': 'Пример обучения утверждён',
    'audit.action.datasetFrozen': 'Датасет заморожен',
    'audit.action.modelActivated': 'Модель активирована',
    'audit.action.modelRolledBack': 'Модель откачена',
    'audit.action.remoteFileCleanupFailed': 'Ошибка очистки файла',
    'audit.action.documentPreviewed': 'Просмотр документа',
    'audit.entity.BankStatementImport': 'Импорт выписки',
    'audit.entity.BankTransaction': 'Банковская операция',
    'audit.entity.CounterpartyMatch': 'Сопоставление контрагента',
    'audit.entity.CounterpartyRule': 'Правило сопоставления',
    'audit.entity.PaymentAllocation': 'Распределение платежа',
    'audit.entity.SyrvePaymentPosting': 'Проведение в Syrve',
    'audit.entity.SyrveConnection': 'Подключение Syrve',
    'audit.entity.SyrveDocumentSyncRun': 'Синхронизация документов',
    'audit.entity.SyrvePostingRule': 'Правило проведения',
    'audit.entity.SyrveDocumentSnapshot': 'Документ Syrve',
    'audit.entity.PaymentAnomaly': 'Аномалия платежа',
    'audit.entity.ManualCorrection': 'Ручная корректировка',
    'audit.entity.ActiveContext': 'Активный контекст',
    'audit.entity.AuditLog': 'Журнал аудита',
    'audit.entity.PlatformSettings': 'Платформенные настройки',
    'audit.entity.PlatformUser': 'Пользователь платформы',
    'audit.entity.Organization': 'Организация',
    'audit.entity.UserInvite': 'Приглашение',
    'audit.entity.AppNotification': 'Уведомление',
    'audit.entity.AdminWorker': 'Фоновый worker',
    'audit.entity.ReconciliationEvidence': 'Evidence сверки',
    'audit.entity.DocumentRecognition': 'Распознавание документа',
    'audit.message.activeContextSelected': 'Выбран активный контекст (организация / точка)',
    'audit.message.allocationApproved': 'Распределение платежа утверждено',
    'audit.message.allocationCancelled': 'Распределение платежа отменено',
    'audit.message.allocationConfirmed': 'Распределение платежа подтверждено',
    'audit.message.anomalyAcknowledged': 'Аномалия принята в работу',
    'audit.message.anomalyDismissed': 'Аномалия отклонена',
    'audit.message.anomalyResolved': 'Аномалия закрыта',
    'audit.message.balanceReviewOverridden': 'Проверка баланса выписки принудительно подтверждена',
    'audit.message.bankStatementImportDeleted': 'Импорт банковской выписки удалён',
    'audit.message.connectionTestExecuted': 'Выполнен тест подключения Syrve',
    'audit.message.counterpartyMatchExcluded': 'Операция исключена из очереди сопоставления',
    'audit.message.counterpartyRuleActivated': 'Правило сопоставления включено',
    'audit.message.counterpartyRuleCreatedFromManual': 'Правило создано из ручного сопоставления',
    'audit.message.counterpartyRuleDeactivated': 'Правило сопоставления выключено',
    'audit.message.counterpartyRuleUpdated': 'Правило сопоставления изменено',
    'audit.message.documentSyncCompleted': 'Синхронизация документов Syrve завершена',
    'audit.message.counterpartyMatchRestored': 'Исключённая операция возвращена в сопоставление',
    'audit.message.manualCounterpartyMatchCreated': 'Контрагент сопоставлен вручную',
    'audit.message.manualCounterpartyMatchReverted': 'Ручное сопоставление контрагента отменено',
    'audit.message.originalBankDocumentPreviewed': 'Открыт просмотр исходного банковского документа',
    'audit.message.originalBankFileDownloaded': 'Скачан исходный файл банковской выписки',
    'audit.message.platformSettingsUpdated': 'Обновлены операционные настройки платформы',
    'audit.message.platformUserCreated': 'Создан пользователь платформы',
    'audit.message.platformUserRoleAssigned': 'Пользователю назначена роль',
    'audit.message.platformUserRoleRemoved': 'У пользователя снята роль',
    'audit.message.platformUserUpdated': 'Пользователь платформы изменён',
    'audit.message.postingApproved': 'Проведение в Syrve утверждено',
    'audit.message.postingProcessedByWorker': 'Проведение обработано фоновым worker',
    'audit.message.postingQueued': 'Проведение поставлено в очередь',
    'audit.message.postingReconciled': 'Выполнена сверка проведения',
    'audit.message.postingRetryScheduled': 'Назначен повтор проведения',
    'audit.message.postingWriteTargetConfigured': 'Заданы счёт и статья ДДС для проведения',
    'audit.message.syrveConnectionCreated': 'Создано подключение Syrve',
    'audit.message.syrveConnectionSoftDeleted': 'Подключение Syrve мягко удалено',
    'audit.message.syrveConnectionUpdated': 'Подключение Syrve изменено',
    'audit.message.syrveCredentialsRotated': 'Учётные данные Syrve ротированы',
    'audit.message.syrvePostingRuleConflict': 'Обнаружен конфликт правила проведения',
    'audit.message.syrvePostingRuleCreated': 'Создано правило проведения',
    'audit.message.syrvePostingRuleDisabled': 'Правило проведения отключено',
    'audit.message.syrvePostingRuleRemembered': 'Запомнено правило проведения (счёт / ДДС) с write-target',
    'audit.message.syrvePostingRuleUpdated': 'Правило проведения изменено',
    'audit.message.syrveServiceAccountEnsured': 'Сервисная учётная запись Syrve проверена/создана',
    'audit.message.userLoggedIn': 'Пользователь вошёл в систему',
    'audit.message.userLoggedOut': 'Пользователь вышел из системы',
    'audit.message.duplicateDismissed': 'Дубль отклонён',
    'audit.message.duplicateConfirmed': 'Дубль подтверждён',
    'audit.message.duplicateUploadRejected': 'Повторная загрузка файла отклонена',
    'audit.message.auditExportGenerated': 'Сформирован экспорт журнала аудита',
    'audit.message.manualCorrectionApplied': 'Применена ручная корректировка',
    'audit.message.manualCorrectionCancelled': 'Ручная корректировка отменена',
  },
  en: {
    'audit.title': 'Audit log',
    'audit.subtitle': 'Who did what to which object. Open a row for details and a link to the object.',
    'audit.narrative.system': 'System',
    'audit.narrative.excludeRule': '{user}: {amount} {currency} operation excluded as “{category}”; key “{pattern}”, additional exclusions {count}.',
    'audit.narrative.manualMatch': '{user}: counterparty “{counterparty}” matched manually.',
    'audit.narrative.matchRule': '{user}: rule “{pattern}” → “{counterparty}” created.',
    'audit.narrative.generic': '{user}: {message} — {entity}.',
    'audit.export.csv': 'CSV',
    'audit.export.pdf': 'PDF',
    'audit.column.time': 'Time',
    'audit.column.user': 'User',
    'audit.column.action': 'Action',
    'audit.column.object': 'Object',
    'audit.column.message': 'What happened',
    'audit.column.details': 'Details',
    'audit.filter.action': 'Action type',
    'audit.filter.entityType': 'Object type',
    'audit.filter.entityId': 'Object ID',
    'audit.filter.userEmail': 'User email',
    'audit.filter.from': 'From (UTC)',
    'audit.filter.to': 'To (UTC)',
    'audit.filter.clear': 'Clear filters',
    'audit.pagination.prev': 'Previous',
    'audit.pagination.next': 'Next',
    'audit.pagination.summary': 'Page {page} · {total} entries',
    'audit.drawer.title': 'Audit entry',
    'audit.drawer.openObject': 'Open object',
    'audit.drawer.rawMessage': 'Original message',
    'audit.drawer.details': 'Technical details',
    'audit.drawer.noDetails': 'No extra details on this entry — use action type and object.',
    'audit.drawer.copyId': 'Entry ID',
    'audit.drawer.highlight.reason': 'Reason',
    'audit.drawer.highlight.amount': 'Amount',
    'audit.drawer.highlight.fileName': 'File',
    'audit.drawer.highlight.status': 'Status',
    'audit.drawer.highlight.changes': 'Changes',
    'audit.empty.title': 'No entries',
    'audit.empty.description': 'No events match the current filters.',
    'audit.hasDetails': 'has JSON',
    'audit.action.created': 'Created',
    'audit.action.updated': 'Updated',
    'audit.action.deleted': 'Deleted',
    'audit.action.login': 'Login',
    'audit.action.logout': 'Logout',
    'audit.action.import': 'Import',
    'audit.action.match': 'Match',
    'audit.action.allocate': 'Allocate',
    'audit.action.postPayment': 'Post payment',
    'audit.action.sync': 'Sync',
    'audit.action.reconcile': 'Reconcile',
    'audit.action.approve': 'Approve',
    'audit.action.cancel': 'Cancel',
    'audit.action.anomalyDetected': 'Anomaly detected',
    'audit.action.anomalyAcknowledged': 'Anomaly acknowledged',
    'audit.action.anomalyResolved': 'Anomaly resolved',
    'audit.action.anomalyDismissed': 'Anomaly dismissed',
    'audit.action.notificationRead': 'Notification read',
    'audit.action.reconciliationRetryRequested': 'Reconciliation retry',
    'audit.action.backOfficeVerificationRecorded': 'Back-office verification',
    'audit.action.notificationReadAll': 'All notifications read',
    'audit.action.softDeleted': 'Soft deleted',
    'audit.action.restored': 'Restored',
    'audit.action.pendingHardDelete': 'Pending hard delete',
    'audit.action.hardDeleted': 'Hard deleted',
    'audit.action.cancelledByHardDelete': 'Cancelled by hard delete',
    'audit.action.export': 'Export',
    'audit.action.documentUploaded': 'Document uploaded',
    'audit.action.recognitionQueued': 'Recognition queued',
    'audit.action.recognitionStarted': 'Recognition started',
    'audit.action.recognitionCompleted': 'Recognition completed',
    'audit.action.recognitionFailed': 'Recognition failed',
    'audit.action.recognitionRetryRequested': 'Recognition retry',
    'audit.action.recognitionRowCorrected': 'Recognition row corrected',
    'audit.action.recognitionConfirmed': 'Recognition confirmed',
    'audit.action.recognitionRejected': 'Recognition rejected',
    'audit.action.trainingCandidateCreated': 'Training candidate created',
    'audit.action.trainingCandidateAnonymized': 'Training candidate anonymized',
    'audit.action.trainingExampleApproved': 'Training example approved',
    'audit.action.datasetFrozen': 'Dataset frozen',
    'audit.action.modelActivated': 'Model activated',
    'audit.action.modelRolledBack': 'Model rolled back',
    'audit.action.remoteFileCleanupFailed': 'Remote file cleanup failed',
    'audit.action.documentPreviewed': 'Document previewed',
    'audit.entity.BankStatementImport': 'Bank statement import',
    'audit.entity.BankTransaction': 'Bank transaction',
    'audit.entity.CounterpartyMatch': 'Counterparty match',
    'audit.entity.CounterpartyRule': 'Counterparty rule',
    'audit.entity.PaymentAllocation': 'Payment allocation',
    'audit.entity.SyrvePaymentPosting': 'Syrve posting',
    'audit.entity.SyrveConnection': 'Syrve connection',
    'audit.entity.SyrveDocumentSyncRun': 'Document sync run',
    'audit.entity.SyrvePostingRule': 'Posting rule',
    'audit.entity.SyrveDocumentSnapshot': 'Syrve document',
    'audit.entity.PaymentAnomaly': 'Payment anomaly',
    'audit.entity.ManualCorrection': 'Manual correction',
    'audit.entity.ActiveContext': 'Active context',
    'audit.entity.AuditLog': 'Audit log',
    'audit.entity.PlatformSettings': 'Platform settings',
    'audit.entity.PlatformUser': 'Platform user',
    'audit.entity.Organization': 'Organization',
    'audit.entity.UserInvite': 'User invite',
    'audit.entity.AppNotification': 'Notification',
    'audit.entity.AdminWorker': 'Admin worker',
    'audit.entity.ReconciliationEvidence': 'Reconciliation evidence',
    'audit.entity.DocumentRecognition': 'Document recognition',
    'audit.message.activeContextSelected': 'Active context selected (organization / outlet)',
    'audit.message.allocationApproved': 'Payment allocation approved',
    'audit.message.allocationCancelled': 'Payment allocation cancelled',
    'audit.message.allocationConfirmed': 'Payment allocation confirmed',
    'audit.message.anomalyAcknowledged': 'Anomaly acknowledged',
    'audit.message.anomalyDismissed': 'Anomaly dismissed',
    'audit.message.anomalyResolved': 'Anomaly resolved',
    'audit.message.balanceReviewOverridden': 'Bank statement balance review overridden',
    'audit.message.bankStatementImportDeleted': 'Bank statement import deleted',
    'audit.message.connectionTestExecuted': 'Syrve connection test executed',
    'audit.message.counterpartyMatchExcluded': 'Transaction excluded from matching queue',
    'audit.message.counterpartyRuleActivated': 'Counterparty rule activated',
    'audit.message.counterpartyRuleCreatedFromManual': 'Rule created from manual match',
    'audit.message.counterpartyRuleDeactivated': 'Counterparty rule deactivated',
    'audit.message.counterpartyRuleUpdated': 'Counterparty rule updated',
    'audit.message.documentSyncCompleted': 'Syrve document sync completed',
    'audit.message.counterpartyMatchRestored': 'Excluded match restored to queue',
    'audit.message.manualCounterpartyMatchCreated': 'Manual counterparty match created',
    'audit.message.manualCounterpartyMatchReverted': 'Manual counterparty match reverted',
    'audit.message.originalBankDocumentPreviewed': 'Original bank document previewed',
    'audit.message.originalBankFileDownloaded': 'Original bank file downloaded',
    'audit.message.platformSettingsUpdated': 'Platform operational settings updated',
    'audit.message.platformUserCreated': 'Platform user created',
    'audit.message.platformUserRoleAssigned': 'Platform user role assigned',
    'audit.message.platformUserRoleRemoved': 'Platform user role removed',
    'audit.message.platformUserUpdated': 'Platform user updated',
    'audit.message.postingApproved': 'Syrve posting approved',
    'audit.message.postingProcessedByWorker': 'Posting processed by worker',
    'audit.message.postingQueued': 'Posting queued',
    'audit.message.postingReconciled': 'Posting reconciled',
    'audit.message.postingRetryScheduled': 'Posting retry scheduled',
    'audit.message.postingWriteTargetConfigured': 'Posting write target (account / cash-flow) configured',
    'audit.message.syrveConnectionCreated': 'Syrve connection created',
    'audit.message.syrveConnectionSoftDeleted': 'Syrve connection soft-deleted',
    'audit.message.syrveConnectionUpdated': 'Syrve connection updated',
    'audit.message.syrveCredentialsRotated': 'Syrve credentials rotated',
    'audit.message.syrvePostingRuleConflict': 'Syrve posting rule conflict detected',
    'audit.message.syrvePostingRuleCreated': 'Syrve posting rule created',
    'audit.message.syrvePostingRuleDisabled': 'Syrve posting rule disabled',
    'audit.message.syrvePostingRuleRemembered': 'Posting rule remembered from write target',
    'audit.message.syrvePostingRuleUpdated': 'Syrve posting rule updated',
    'audit.message.syrveServiceAccountEnsured': 'Syrve service account ensured',
    'audit.message.userLoggedIn': 'User logged in',
    'audit.message.userLoggedOut': 'User logged out',
    'audit.message.duplicateDismissed': 'Duplicate dismissed',
    'audit.message.duplicateConfirmed': 'Duplicate confirmed',
    'audit.message.duplicateUploadRejected': 'Duplicate upload rejected',
    'audit.message.auditExportGenerated': 'Audit log export generated',
    'audit.message.manualCorrectionApplied': 'Manual correction applied',
    'audit.message.manualCorrectionCancelled': 'Manual correction cancelled',
  },
  id: {
    'audit.title': 'Audit log',
    'audit.subtitle': 'Siapa melakukan apa pada objek mana. Buka baris untuk detail dan tautan objek.',
    'audit.narrative.system': 'Sistem',
    'audit.narrative.excludeRule': '{user}: operasi {amount} {currency} dikecualikan sebagai “{category}”; kunci “{pattern}”, pengecualian tambahan {count}.',
    'audit.narrative.manualMatch': '{user}: counterparty “{counterparty}” dicocokkan manual.',
    'audit.narrative.matchRule': '{user}: aturan “{pattern}” → “{counterparty}” dibuat.',
    'audit.narrative.generic': '{user}: {message} — {entity}.',
    'audit.export.csv': 'CSV',
    'audit.export.pdf': 'PDF',
    'audit.column.time': 'Waktu',
    'audit.column.user': 'Pengguna',
    'audit.column.action': 'Tindakan',
    'audit.column.object': 'Objek',
    'audit.column.message': 'Apa yang terjadi',
    'audit.column.details': 'Detail',
    'audit.filter.action': 'Jenis tindakan',
    'audit.filter.entityType': 'Jenis objek',
    'audit.filter.entityId': 'ID objek',
    'audit.filter.userEmail': 'Email pengguna',
    'audit.filter.from': 'Dari (UTC)',
    'audit.filter.to': 'Sampai (UTC)',
    'audit.filter.clear': 'Reset filter',
    'audit.pagination.prev': 'Sebelumnya',
    'audit.pagination.next': 'Berikutnya',
    'audit.pagination.summary': 'Hal. {page} · {total} entri',
    'audit.drawer.title': 'Entri audit',
    'audit.drawer.openObject': 'Buka objek',
    'audit.drawer.rawMessage': 'Pesan asli',
    'audit.drawer.details': 'Detail teknis',
    'audit.drawer.noDetails': 'Tidak ada detail tambahan — lihat jenis tindakan dan objek.',
    'audit.drawer.copyId': 'ID entri',
    'audit.drawer.highlight.reason': 'Alasan',
    'audit.drawer.highlight.amount': 'Jumlah',
    'audit.drawer.highlight.fileName': 'File',
    'audit.drawer.highlight.status': 'Status',
    'audit.drawer.highlight.changes': 'Perubahan',
    'audit.empty.title': 'Tidak ada entri',
    'audit.empty.description': 'Tidak ada peristiwa untuk filter saat ini.',
    'audit.hasDetails': 'ada JSON',
    'audit.action.created': 'Dibuat',
    'audit.action.updated': 'Diubah',
    'audit.action.deleted': 'Dihapus',
    'audit.action.login': 'Masuk',
    'audit.action.logout': 'Keluar',
    'audit.action.import': 'Impor',
    'audit.action.match': 'Pencocokan',
    'audit.action.allocate': 'Alokasi',
    'audit.action.postPayment': 'Posting pembayaran',
    'audit.action.sync': 'Sinkronisasi',
    'audit.action.reconcile': 'Rekonsiliasi',
    'audit.action.approve': 'Persetujuan',
    'audit.action.cancel': 'Batal',
    'audit.action.anomalyDetected': 'Anomali terdeteksi',
    'audit.action.anomalyAcknowledged': 'Anomali diakui',
    'audit.action.anomalyResolved': 'Anomali diselesaikan',
    'audit.action.anomalyDismissed': 'Anomali ditolak',
    'audit.action.notificationRead': 'Notifikasi dibaca',
    'audit.action.reconciliationRetryRequested': 'Ulang rekonsiliasi',
    'audit.action.backOfficeVerificationRecorded': 'Verifikasi back-office',
    'audit.action.notificationReadAll': 'Semua notifikasi dibaca',
    'audit.action.softDeleted': 'Soft delete',
    'audit.action.restored': 'Dipulihkan',
    'audit.action.pendingHardDelete': 'Menunggu hard delete',
    'audit.action.hardDeleted': 'Hard delete',
    'audit.action.cancelledByHardDelete': 'Dibatalkan hard delete',
    'audit.action.export': 'Ekspor',
    'audit.action.documentUploaded': 'Dokumen diunggah',
    'audit.action.recognitionQueued': 'Pengenalan antre',
    'audit.action.recognitionStarted': 'Pengenalan dimulai',
    'audit.action.recognitionCompleted': 'Pengenalan selesai',
    'audit.action.recognitionFailed': 'Pengenalan gagal',
    'audit.action.recognitionRetryRequested': 'Ulang pengenalan',
    'audit.action.recognitionRowCorrected': 'Baris pengenalan dikoreksi',
    'audit.action.recognitionConfirmed': 'Pengenalan dikonfirmasi',
    'audit.action.recognitionRejected': 'Pengenalan ditolak',
    'audit.action.trainingCandidateCreated': 'Kandidat pelatihan dibuat',
    'audit.action.trainingCandidateAnonymized': 'Kandidat dianonimkan',
    'audit.action.trainingExampleApproved': 'Contoh pelatihan disetujui',
    'audit.action.datasetFrozen': 'Dataset dibekukan',
    'audit.action.modelActivated': 'Model diaktifkan',
    'audit.action.modelRolledBack': 'Model di-rollback',
    'audit.action.remoteFileCleanupFailed': 'Pembersihan file gagal',
    'audit.action.documentPreviewed': 'Pratinjau dokumen',
    'audit.entity.BankStatementImport': 'Impor rekening koran',
    'audit.entity.BankTransaction': 'Transaksi bank',
    'audit.entity.CounterpartyMatch': 'Pencocokan counterparty',
    'audit.entity.CounterpartyRule': 'Aturan pencocokan',
    'audit.entity.PaymentAllocation': 'Alokasi pembayaran',
    'audit.entity.SyrvePaymentPosting': 'Posting Syrve',
    'audit.entity.SyrveConnection': 'Koneksi Syrve',
    'audit.entity.SyrveDocumentSyncRun': 'Sinkron dokumen',
    'audit.entity.SyrvePostingRule': 'Aturan posting',
    'audit.entity.SyrveDocumentSnapshot': 'Dokumen Syrve',
    'audit.entity.PaymentAnomaly': 'Anomali pembayaran',
    'audit.entity.ManualCorrection': 'Koreksi manual',
    'audit.entity.ActiveContext': 'Konteks aktif',
    'audit.entity.AuditLog': 'Audit log',
    'audit.entity.PlatformSettings': 'Pengaturan platform',
    'audit.entity.PlatformUser': 'Pengguna platform',
    'audit.entity.Organization': 'Organisasi',
    'audit.entity.UserInvite': 'Undangan',
    'audit.entity.AppNotification': 'Notifikasi',
    'audit.entity.AdminWorker': 'Admin worker',
    'audit.entity.ReconciliationEvidence': 'Bukti rekonsiliasi',
    'audit.entity.DocumentRecognition': 'Pengenalan dokumen',
    'audit.message.activeContextSelected': 'Konteks aktif dipilih (organisasi / outlet)',
    'audit.message.allocationApproved': 'Alokasi pembayaran disetujui',
    'audit.message.allocationCancelled': 'Alokasi pembayaran dibatalkan',
    'audit.message.allocationConfirmed': 'Alokasi pembayaran dikonfirmasi',
    'audit.message.anomalyAcknowledged': 'Anomali diakui',
    'audit.message.anomalyDismissed': 'Anomali ditolak',
    'audit.message.anomalyResolved': 'Anomali diselesaikan',
    'audit.message.balanceReviewOverridden': 'Review saldo rekening koran di-override',
    'audit.message.bankStatementImportDeleted': 'Impor rekening koran dihapus',
    'audit.message.connectionTestExecuted': 'Tes koneksi Syrve dijalankan',
    'audit.message.counterpartyMatchExcluded': 'Transaksi dikecualikan dari antrean pencocokan',
    'audit.message.counterpartyRuleActivated': 'Aturan pencocokan diaktifkan',
    'audit.message.counterpartyRuleCreatedFromManual': 'Aturan dibuat dari pencocokan manual',
    'audit.message.counterpartyRuleDeactivated': 'Aturan pencocokan dinonaktifkan',
    'audit.message.counterpartyRuleUpdated': 'Aturan pencocokan diubah',
    'audit.message.documentSyncCompleted': 'Sinkron dokumen Syrve selesai',
    'audit.message.counterpartyMatchRestored': 'Pengecualian dikembalikan ke antrean',
    'audit.message.manualCounterpartyMatchCreated': 'Pencocokan counterparty manual dibuat',
    'audit.message.manualCounterpartyMatchReverted': 'Pencocokan manual dibatalkan',
    'audit.message.originalBankDocumentPreviewed': 'Pratinjau dokumen bank asli',
    'audit.message.originalBankFileDownloaded': 'File bank asli diunduh',
    'audit.message.platformSettingsUpdated': 'Pengaturan operasional platform diubah',
    'audit.message.platformUserCreated': 'Pengguna platform dibuat',
    'audit.message.platformUserRoleAssigned': 'Peran pengguna ditetapkan',
    'audit.message.platformUserRoleRemoved': 'Peran pengguna dihapus',
    'audit.message.platformUserUpdated': 'Pengguna platform diubah',
    'audit.message.postingApproved': 'Posting Syrve disetujui',
    'audit.message.postingProcessedByWorker': 'Posting diproses worker',
    'audit.message.postingQueued': 'Posting diantrekan',
    'audit.message.postingReconciled': 'Posting direkonsiliasi',
    'audit.message.postingRetryScheduled': 'Retry posting dijadwalkan',
    'audit.message.postingWriteTargetConfigured': 'Write target posting (akun / arus kas) dikonfigurasi',
    'audit.message.syrveConnectionCreated': 'Koneksi Syrve dibuat',
    'audit.message.syrveConnectionSoftDeleted': 'Koneksi Syrve soft-delete',
    'audit.message.syrveConnectionUpdated': 'Koneksi Syrve diubah',
    'audit.message.syrveCredentialsRotated': 'Kredensial Syrve dirotasi',
    'audit.message.syrvePostingRuleConflict': 'Konflik aturan posting terdeteksi',
    'audit.message.syrvePostingRuleCreated': 'Aturan posting dibuat',
    'audit.message.syrvePostingRuleDisabled': 'Aturan posting dinonaktifkan',
    'audit.message.syrvePostingRuleRemembered': 'Aturan posting diingat dari write target',
    'audit.message.syrvePostingRuleUpdated': 'Aturan posting diubah',
    'audit.message.syrveServiceAccountEnsured': 'Akun layanan Syrve dipastikan',
    'audit.message.userLoggedIn': 'Pengguna masuk',
    'audit.message.userLoggedOut': 'Pengguna keluar',
    'audit.message.duplicateDismissed': 'Duplikat ditolak',
    'audit.message.duplicateConfirmed': 'Duplikat dikonfirmasi',
    'audit.message.duplicateUploadRejected': 'Unggahan duplikat ditolak',
    'audit.message.auditExportGenerated': 'Ekspor audit log dibuat',
    'audit.message.manualCorrectionApplied': 'Koreksi manual diterapkan',
    'audit.message.manualCorrectionCancelled': 'Koreksi manual dibatalkan',
  },
} as const;
